import { render, staticRenderFns } from "./DriverAddInProgress.vue?vue&type=template&id=2b826808&scoped=true&"
import script from "./DriverAddInProgress.vue?vue&type=script&lang=js&"
export * from "./DriverAddInProgress.vue?vue&type=script&lang=js&"
import style0 from "./DriverAddInProgress.vue?vue&type=style&index=0&id=2b826808&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b826808",
  null
  
)

export default component.exports